import { render, staticRenderFns } from "./CalculatorScoreboardLayout.vue?vue&type=template&id=1a8a1648&scoped=true&"
import script from "./CalculatorScoreboardLayout.vue?vue&type=script&lang=js&"
export * from "./CalculatorScoreboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorScoreboardLayout.vue?vue&type=style&index=0&id=1a8a1648&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a1648",
  null
  
)

export default component.exports